import React from 'react';
import PropTypes from 'prop-types';
import Notes from './Notes';

const EventAgenda = ({ event }) => (
  <span>
    <div>
      {event.title}
      {event.notes && <Notes notes={event.notes} />}
    </div>
  </span>
);

EventAgenda.propTypes = {
  event: PropTypes.object.isRequired
};

export default EventAgenda;
